import { useState } from 'react';
import { toast } from 'sonner';
import { useUser } from '../contexts/user-context/use-user';

export const useAccountAPI = () => {
  const { authenticatedFetch } = useUser();
  const [isSyncing, setIsSyncing] = useState(false);

  const syncAccount = async (accountId: string): Promise<void> => {
    try {
      setIsSyncing(true);
      const response = await authenticatedFetch(`/api/accounts/${accountId}/sync`, {
        method: 'POST',
      });

      if (response.ok) {
        return await response.json();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error syncing account');
      }
    } catch {
      toast.error('There was a problem syncing your account');
    } finally {
      setIsSyncing(false);
    }
  };

  const syncAccounts = async (companyId: string): Promise<void> => {
    try {
      setIsSyncing(true);
      const response = await authenticatedFetch(`/api/companies/${companyId}/accounts/sync`, {
        method: 'POST',
      });

      if (response.ok) {
        return await response.json();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error syncing accounts');
      }
    } catch {
      toast.error('There was a problem syncing your accounts');
    } finally {
      setIsSyncing(false);
    }
  };

  const deleteAccount = async (accountId: string): Promise<void> => {
    const response = await authenticatedFetch(`/api/accounts/${accountId}/unlink`, {
      method: 'POST',
    });

    if (response.ok) {
      return await response.json();
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error deleting account');
    }
  };

  return {
    syncAccount,
    syncAccounts,
    deleteAccount,
    isSyncing,
  };
};
